export interface ValueChipData {
  label: string;
  variant: "blue" | "amber" | "green" | "red";
}

export interface RequirementRow {
  id: string;
  label: string;
  detail: string;
  required: string;
  isOptional: boolean;
  chip?: ValueChipData;
  isAccepted?: boolean | null;
}

export interface RequirementSection {
  id: number;
  icon: string;
  title: string;
  rows: RequirementRow[];
}

export interface ProjectInfo {
  name: string;
  type: string;
  address: string;
  company: string;
  lenderLabel: string;
  lenderName: string;
}

export interface SigDefaults {
  name: string;
  title: string;
  company: string;
  date: string;
}

export const TOTAL_REQUIREMENTS = 16;

// Use {bold|text} syntax inside detail strings — RequirementRow parses and renders it.
export const sections: RequirementSection[] = [
  // {
  //   id: 1,
  //   icon: "💰",
  //   title: "Draw & Disbursement Requirements ",
  //   rows: [
  //     {
  //       id: "1-1",
  //       label: "AIA Application for Payment (G702 & G703)",
  //       detail:
  //         "All draw requests must be submitted using the AIA G702 Application for Payment and G703 Continuation Sheet. Requisitions must be signed by the authorized Owner/Borrower prior to submission.",
  //       required: "★ Required by TD Bank",
  //       isOptional: false,
  //     },
  //     {
  //       id: "1-2",
  //       label: "Subcontractor & Supplier Invoices",
  //       detail:
  //         "Invoices from all subcontractors and suppliers must be attached to each draw request. Invoices must match the line items being billed on the G703.",
  //       required: "★ Required by TD Bank",
  //       isOptional: false,
  //     },
  //     {
  //       id: "1-3",
  //       label: "Retainage",
  //       detail:
  //         "TD Bank will withhold {bold|10% retainage} on all draws until the project reaches substantial completion. Retainage will be released upon final inspection and receipt of all close-out documents.",
  //       chip: { label: "10% Retainage", variant: "blue" },
  //       required: "★ Required by TD Bank",
  //       isOptional: false,
  //     },
  //     {
  //       id: "1-4",
  //       label: "Equity Contribution",
  //       detail:
  //         "Owner equity must be injected into the project prior to the release of any loan funds. The lender will verify equity has been satisfied before approving each draw. GC acknowledges that equity is tracked separately by the lender.",
  //       required: "★ Required by TD Bank",
  //       isOptional: false,
  //     },
  //     {
  //       id: "1-5",
  //       label: "Draw Schedule & Frequency",
  //       detail:
  //         "Draws may be submitted no more than once per month. Each draw submission will trigger a CSC field inspection before funds are released. Draws submitted without a completed CSC inspection will not be processed.",
  //       required: "★ Required by TD Bank & CSC",
  //       isOptional: false,
  //     },
  //   ],
  // },
  // {
  //   id: 2,
  //   icon: "📝",
  //   title: "Lien Waiver Requirements",
  //   rows: [
  //     {
  //       id: "2-1",
  //       label: "Lien Waivers Required on All Draws",
  //       detail:
  //         "TD Bank requires a Conditional or Unconditional Lien Waiver from every subcontractor and supplier being paid in each draw. Waivers must be submitted to CSC with each Application for Payment.",
  //       required: "★ Required by TD Bank",
  //       isOptional: false,
  //     },
  //     {
  //       id: "2-2",
  //       label: "Lien Waiver Threshold",
  //       detail:
  //         "Lien waivers are required for all vendors being paid {bold|$5,000 or more} in a single draw. Vendors paid less than the threshold in a given draw are exempt from that draw's waiver requirement, but a final lien waiver is required from all vendors at close-out.",
  //       chip: { label: "$5,000 Minimum Threshold", variant: "amber" },
  //       required: "★ Required by TD Bank",
  //       isOptional: false,
  //     },
  //     {
  //       id: "2-3",
  //       label: "Digital Lien Waiver Platform",
  //       detail:
  //         "CSC New England provides a digital lien waiver collection system. GC is responsible for initiating waiver requests to all subs via the platform. Subs receive a pre-filled signing link by email or SMS — no login required. GC is responsible for tracking outstanding waivers and following up as needed.",
  //       required: "★ Required by CSC",
  //       isOptional: false,
  //     },
  //   ],
  // },
  // {
  //   id: 3,
  //   icon: "🛡",
  //   title: "Insurance & Bond Requirements",
  //   rows: [
  //     {
  //       id: "3-1",
  //       label: "General Liability & Workers' Compensation",
  //       detail:
  //         "GC must maintain General Liability Insurance ($1,000,000 per occurrence / $2,000,000 aggregate) and Workers' Compensation coverage for the duration of the project. All subcontractors must carry their own GL and WC and provide certificates upon request.",
  //       chip: { label: "$1M / $2M GL Coverage", variant: "blue" },
  //       required: "★ Required by TD Bank",
  //       isOptional: false,
  //     },
  //     {
  //       id: "3-2",
  //       label: "Builder's Risk Insurance",
  //       detail:
  //         "Builder's Risk insurance must be maintained for the full replacement value of the project for the duration of construction. A current certificate must be on file with the lender and updated at each renewal. TD Bank must be named as additional insured.",
  //       required: "★ Required by TD Bank",
  //       isOptional: false,
  //     },
  //     {
  //       id: "3-3",
  //       label: "Performance & Payment Bond",
  //       detail:
  //         "TD Bank does not require a Performance and Payment Bond for this project. If a bond is obtained voluntarily, a copy must be provided to the lender and CSC.",
  //       chip: { label: "Not Required — This Project", variant: "green" },
  //       required: "○ Optional for this project",
  //       isOptional: true,
  //     },
  //   ],
  // },
  // {
  //   id: 4,
  //   icon: "🔍",
  //   title: "Inspections & CSC Reporting",
  //   rows: [
  //     {
  //       id: "4-1",
  //       label: "CSC Field Inspection Before Every Draw",
  //       detail:
  //         "A field inspection by a CSC New England inspector is required before each draw disbursement. The GC must ensure site access and a knowledgeable site representative is available at the time of inspection. Inspections are typically scheduled within 5 business days of draw submission.",
  //       required: "★ Required by TD Bank & CSC",
  //       isOptional: false,
  //     },
  //     {
  //       id: "4-2",
  //       label: "Monthly Progress Meetings",
  //       detail:
  //         "TD Bank requires a monthly progress meeting with the Owner, GC, and lending officer. CSC may attend at the bank's request. Meetings must be scheduled and confirmed at least 48 hours in advance. GC is responsible for maintaining meeting minutes.",
  //       chip: { label: "Monthly · First Wednesday", variant: "blue" },
  //       required: "★ Required by TD Bank",
  //       isOptional: false,
  //     },
  //     {
  //       id: "4-3",
  //       label: "Change Order Notification",
  //       detail:
  //         "Any change orders that affect the project scope, budget, or schedule must be submitted through the CSC platform before the work is performed. Change orders that increase the contract value by more than {bold|$5,000} require bank approval before proceeding. Verbal agreements are not binding.",
  //       chip: { label: "$5,000 Bank Approval Threshold", variant: "amber" },
  //       required: "★ Required by TD Bank",
  //       isOptional: false,
  //     },
  //   ],
  // },
  // {
  //   id: 5,
  //   icon: "📊",
  //   title: "Budget, Soft Costs & Contingency",
  //   rows: [
  //     {
  //       id: "5-1",
  //       label: "Soft Cost Tracking",
  //       detail:
  //         "TD Bank requires tracking of all soft costs (architect fees, permits, engineering, legal, etc.) separately from hard construction costs. Soft cost disbursements require supporting invoices and must be included in the draw application. Soft costs may not exceed the amount established in the approved budget without bank authorization.",
  //       required: "★ Required by TD Bank",
  //       isOptional: false,
  //     },
  //     {
  //       id: "5-2",
  //       label: "Contingency Use & Notification",
  //       detail:
  //         "The project contingency may not be drawn upon without prior written notification to TD Bank and CSC. Each contingency draw must identify the specific unforeseen condition or scope change it is addressing. Contingency may not be used for GC overhead, profit, or originally scoped work.",
  //       required: "★ Required by TD Bank",
  //       isOptional: false,
  //     },
  //   ],
  // },
];

export const projectInfo: ProjectInfo = {
  name: "Aroma Joes – Portland",
  type: "Commercial",
  address: "30 Wells Plaza, Portland, ME",
  company: "DeStefano & Associates, Inc.",
  lenderLabel: "Lender",
  lenderName: "TD Bank",
};

export const sigDefaults: SigDefaults = {
  name: "John DeStefano",
  title: "President",
  company: "DeStefano & Associates, Inc.",
  date: "2026-03-26",
};

export const successDeliveries: string[] = [
  // "Five Star Holdings LLC — Owner notified",
  "Signed PDF attached to project record",
  "First draw disbursement now authorized — pending pre-construction report approval",
];
